export const resetNewCountryFields = (form: {
  setFieldsValue: (values: Record<string, string | number | null>) => void;
}) => {
  form.setFieldsValue({
    newCountry: null,
    countryData: null,
    providerPrice: null,
    margin: null,
    exchangeRate: null,
    taxRate: null,
    nudosPriceUsd: null,
    nudosPrice: null,
    nudosPriceUsdWithTaxes: null,
    nudosPriceWithTaxes: null,
    providerId: null,
    availableProviders: null,
    isActive: null,
    newCountryIsActive: null,
    newCountryIsQuoteProduct: null,
    name: null,
    flag: null,
    inStock: null
  });
};

export const normalizeNumericValue = (value?: number | null | string): number => {
  return value !== null && value !== undefined ? +value : 0;
};
